import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import FlexBox from '../../../../../components/FlexBox';
import messages from '../../messages';
import OptionsContainer from '../../../components/OptionsContainer';
import Textbox from '../../../components/Textbox';
import PageSectionHeader from '../../../components/PageSectionHeader';
import { checkDateOnly, required } from '../../../../../utils/validation/validator';
import { Validate, ErrorMessage } from '../../../../../components/Validation';
import FlightDatePicker from '../../../components/FlightDatePicker/index';
import AsyncButton from '../../../../../components/AsyncButton/index';
import DatePicker from '../../../components/DatePicker/index';
import Section from '../../../components/Section';
import ControlContainer from '../../../components/ControlContainer';
import TextArea from '../../../components/TextArea';

export class FlightDetailsForDamagedLost extends React.Component {
  onChange = () => {
    this.props.getFlightStatus();
  };

  render() {
    const { isReadOnly } = this.props;
    const {
      typeOfTransportForDamaged,
      flightNumberForDamaged,
      flightDateForDamaged,
      flightDetailsForDamaged = {},
      cruiseLineDetailsForDamaged = {},
      otherDetailsForDamaged = {},
    } = this.props.isSummary ? this.props.summaryFormValue() : this.props.form;
    const isFlightNumberValid = this.props.checkFlightNumberOnly(flightNumberForDamaged);
    const isFlightDateValid = this.props.checkFlightDateOnly(flightDateForDamaged);
    const flights = flightDetailsForDamaged.flights || [];
    const flightDetail = flights.length === 1 ? flights[0] : flights[flightDetailsForDamaged.selectedFlightIndex];
    const showSectionFlightDetails = flightDetailsForDamaged && (flightDetailsForDamaged.onSuccessFlighAPIRequest || flightDetailsForDamaged.callFailFlighAPIRequest);
    const isDisable = isReadOnly || (flightDetailsForDamaged && (flightDetailsForDamaged.onSuccessFlighAPIRequest || !flightDetailsForDamaged.manuallyEnterFlight));
    return (
      <div>
        <div className={'pt-2'} style={{ fontWeight: 'bold' }}>
          <FormattedMessage {...messages.typeOfTransport} />
        </div>
        <div className={'ml-2 row pt-2'}>
          <div className={'col-sm-12 form-group'}>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="airline"
                  checked={typeOfTransportForDamaged === 'airline'}
                  onChange={this.props.handleChangeTypeOfTransport('form.typeOfTransportForDamaged')}
                />
                <FormattedMessage {...messages.airline} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="cruiseLine"
                  checked={typeOfTransportForDamaged === 'cruiseLine'}
                  onChange={this.props.handleChangeTypeOfTransport('form.typeOfTransportForDamaged')}
                />
                <FormattedMessage {...messages.cruiseLine} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="other"
                  checked={typeOfTransportForDamaged === 'other'}
                  onChange={this.props.handleChangeTypeOfTransport('form.typeOfTransportForDamaged')}
                />
                <FormattedMessage {...messages.other} />
              </OptionsContainer>
            </FlexBox>
          </div>
        </div>
        {typeOfTransportForDamaged === 'airline' &&
          <div className={'ml-2'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.pleaseEnterYourFlightNumberAndDateBelow} />
            </PageSectionHeader>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="flightNumber"
                  validators={[this.props.checkFlightNumberOnly, required]}
                  group={this.props.validatorGroup}
                  addValidatorToGroup={this.props.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.props.validatorGroup.validChangeInGroup}
                  validationCounter={this.props.validationCounter}
                  validatorLeaveGroup={this.props.validatorGroup.removeValidatorToGroup}
                  defaultValue={flightNumberForDamaged}
                  fieldName={messages.flightNumber}
                >
                  <Textbox
                    name="flightNumber"
                    type="text"
                    onChange={this.props.handleChange('form.flightNumberForDamaged')}
                    value={flightNumberForDamaged}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.flightNumber}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkFlightNumberOnly">
                    <FormattedMessage
                      {...messages.checkFlightNumber}
                      values={messages.flightNumber}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="flightDate"
                  validators={[this.props.checkFlightDateOnly, required]}
                  group={this.props.validatorGroup}
                  addValidatorToGroup={this.props.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.props.validatorGroup.validChangeInGroup}
                  validationCounter={this.props.validationCounter}
                  validatorLeaveGroup={this.props.validatorGroup.removeValidatorToGroup}
                  defaultValue={flightDateForDamaged}
                  fieldName={messages.flightDate}
                >
                  <FlightDatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="flightDate"
                    type="text"
                    onDayChange={this.props.handleDayChange('form.flightDateForDamaged')}
                    value={flightDateForDamaged}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.flightDate}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkFlightDateOnly">
                    <FormattedMessage
                      {...messages.checkFlightDate}
                      values={messages.flightDate}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-2 form-group'}></div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <AsyncButton
                  id="searchFlightButton"
                  className={'btn-authentication'}
                  disabled={isReadOnly || (!isFlightNumberValid && !isFlightDateValid)}
                  loading={this.props.loading}
                  spinner={this.props.showSpinnerForElement('searchFlightButton')}
                  onClick={this.props.flightVerificationForDamaged('flightDetailsForDamaged')}
                >
                  Search Flight
                </AsyncButton>
              </div>
            </div>
            {flightDetailsForDamaged.onPendingFlighAPIRequest && (
              <div className={'ml-2 row'}>
                <div style={{ fontWeight: 'bold' }}>
                  <FormattedMessage {...messages.pendingFlightApiRequest} />
                </div>
              </div>
            )}
            {flightDetailsForDamaged.callFailFlighAPIRequest && flightDetailsForDamaged && flightDetailsForDamaged.error && (
              <div className={'row'}>
                <div className={'col-sm-12'} style={{ color: 'red' }}>
                  {flightDetailsForDamaged.error}
                </div>
              </div>
            )}
            {flightDetailsForDamaged.callFailFlighAPIRequest && flightDetail && (
              <div className={'row'}>
                <div className={'form-group col-md-6'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="signature"
                      checked={flightDetailsForDamaged.manuallyEnterFlight === true}
                      onChange={this.props.handleChange('form.flightDetailsForDamaged.manuallyEnterFlight')}
                    />
                    <span>
                      <FormattedMessage {...messages.manuallyEnterFlight} />
                    </span>
                  </OptionsContainer>
                </div>
                <div className={'form-group col-md-6'}>
                </div>
              </div>
            )}
            {(flightDetailsForDamaged.onSuccessFlighAPIRequest && flights.length > 1) && (
              <div className="row">
                <div className="col-sm-12">
                  <PageSectionHeader>
                    <FormattedMessage {...messages.pleaseSelectYourFlightBelow} />
                  </PageSectionHeader>
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th />
                          <th><FormattedMessage {...messages.originAirport} /></th>
                          <th><FormattedMessage {...messages.destinationAirport} /></th>
                          <th><FormattedMessage {...messages.scheduledDeparture} /></th>
                        </tr>
                      </thead>
                      <tbody>
                        {flights.map((flight, index) => (
                          <tr key={index}>
                            <td>
                              <input
                                type="radio"
                                name="selectedFlight"
                                value={index}
                                checked={flightDetailsForDamaged.selectedFlightIndex === index}
                                onChange={() => this.props.handleFlightSelection('form.flightDetailsForDamaged.selectedFlightIndex', index)}
                                disabled={isReadOnly}
                              />
                            </td>
                            <td>{flight.originAirport}</td>
                            <td>{flight.destinationAirport}</td>
                            <td>{flight.flightDate}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
            {(showSectionFlightDetails && flightDetail) && (
              <div className={'row'}>
                <div className={'col-sm-12'}>
                  <Section>
                    <ControlContainer>
                      <div className={'row'}>
                        <div className={'col-sm-2'}>
                        </div>
                        <div className={'col-sm-3'}>
                          <h4>
                            <FormattedMessage {...messages.flightDetails} />
                          </h4>
                        </div>
                        <div className={'col-sm-3'}>
                          <strong>
                            <FormattedMessage {...messages.searchSuccess} />:
                          </strong>{' '}
                          {flightDetailsForDamaged.success ? 'Yes' : 'No'}
                        </div>
                        <div className={'col-sm-2'}>
                        </div>
                      </div>
                      <div className={'row'}>
                        <div className={'col-sm-6 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.flightNumber} />
                          </PageSectionHeader>
                          <Textbox
                            name="flightNumber"
                            type="text"
                            onChange={this.props.handleChangeFlightDetail('flightDetailsForDamaged', 'flightNumber')}
                            value={flightDetail.flightNumber}
                            disabled={isDisable}
                          />
                        </div>
                        <div className={'col-sm-6 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.flightDate} />
                          </PageSectionHeader>
                          <DatePicker
                            name="flightDate"
                            type="text"
                            onDayChange={this.props.handleChangeFlightDetail('flightDetailsForDamaged', 'flightDate')}
                            value={flightDetail.flightDate}
                            disabled={isDisable}
                          />
                        </div>
                      </div>
                      <div className={'row'}>
                        <div className={'col-sm-12 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.airline} />
                          </PageSectionHeader>
                          <Textbox
                            name="airline"
                            type="text"
                            onChange={this.props.handleChangeFlightDetail('flightDetailsForDamaged', 'airline')}
                            value={flightDetail.airline}
                            disabled={isDisable}
                          />
                        </div>
                      </div>
                      <div className={'row'}>
                        <div className={'col-sm-6 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.originAirport} />
                          </PageSectionHeader>
                          <Textbox
                            name="originAirport"
                            type="text"
                            onChange={this.props.handleChangeFlightDetail('flightDetailsForDamaged', 'originAirport')}
                            value={flightDetail.originAirport}
                            disabled={isDisable}
                          />
                        </div>
                        <div className={'col-sm-6 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.destinationAirport} />
                          </PageSectionHeader>
                          <Textbox
                            name="destinationAirport"
                            type="text"
                            onChange={this.props.handleChangeFlightDetail('flightDetailsForDamaged', 'destinationAirport')}
                            value={flightDetail.destinationAirport}
                            disabled={isDisable}
                          />
                        </div>
                      </div>
                      {!isDisable && (
                        <div className={'row'}>
                          <div className={'col-sm-6 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.scheduledOut} />
                            </PageSectionHeader>
                            <DatePicker
                              name="scheduledOut"
                              type="text"
                              onDayChange={this.props.handleChangeFlightDetail('flightDetailsForDamaged', 'scheduledOut')}
                              value={flightDetail.scheduledOut}
                              disabled={isDisable}
                            />
                          </div>
                          <div className={'col-sm-6 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.scheduledIn} />
                            </PageSectionHeader>
                            <DatePicker
                              name="scheduledIn"
                              type="text"
                              onDayChange={this.props.handleChangeFlightDetail('flightDetailsForDamaged', 'scheduledIn')}
                              value={flightDetail.scheduledIn}
                              disabled={isDisable}
                            />
                          </div>
                        </div>
                      )}
                      {isDisable && (
                        <div className={'row'}>
                          <div className={'col-sm-6 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.scheduledOut} />
                            </PageSectionHeader>
                            <Textbox
                              name="scheduledOut"
                              type="text"
                              onDayChange={this.props.handleChangeFlightDetail('flightDetailsForDamaged', 'scheduledOut')}
                              value={flightDetail.scheduledOut}
                              disabled={isDisable}
                            />
                          </div>
                          <div className={'col-sm-6 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.scheduledIn} />
                            </PageSectionHeader>
                            <Textbox
                              name="scheduledIn"
                              type="text"
                              onDayChange={this.props.handleChangeFlightDetail('flightDetailsForDamaged', 'scheduledIn')}
                              value={flightDetail.scheduledIn}
                              disabled={isDisable}
                            />
                          </div>
                        </div>
                      )}
                      <div className={'row'}>
                        <div className={'col-sm-3 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.departureDelay} />
                          </PageSectionHeader>
                          <Textbox
                            name="departureDelay"
                            type="number"
                            onChange={this.props.handleChangeFlightDetail('flightDetailsForDamaged', 'departureDelay')}
                            value={flightDetail.departureDelay}
                            disabled={isDisable}
                          />
                        </div>
                        <div className={'col-sm-3 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.arrivalDelay} />
                          </PageSectionHeader>
                          <Textbox
                            name="arrivalDelay"
                            type="number"
                            onChange={this.props.handleChangeFlightDetail('flightDetailsForDamaged', 'arrivalDelay')}
                            value={flightDetail.arrivalDelay}
                            disabled={isDisable}
                          />
                        </div>
                        <div className={'col-sm-6 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.cancelled} />
                          </PageSectionHeader>
                          <select
                            name="cancelled"
                            className="form-control"
                            onChange={this.props.handleChangeFlightDetail('flightDetailsForDamaged', 'cancelled')}
                            value={flightDetail.cancelled || ''}
                            disabled={isDisable}
                          >
                            <option value="">Select status</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>
                        </div>
                      </div>
                    </ControlContainer>
                  </Section>
                </div>
              </div>
            )}
          </div>
        }
        {typeOfTransportForDamaged === 'cruiseLine' &&
          <div className={'ml-2'}>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.cruiseLine} />
                </PageSectionHeader>
                <Textbox
                  name="cruiseLine"
                  type="text"
                  onChange={this.props.handleChange('form.cruiseLineDetailsForDamaged.cruiseLine')}
                  value={cruiseLineDetailsForDamaged.cruiseLine}
                  disabled={isReadOnly}
                />
              </div>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.cruiseNumber} />
                </PageSectionHeader>
                <Textbox
                  name="cruiseNumber"
                  type="text"
                  onChange={this.props.handleChange('form.cruiseLineDetailsForDamaged.cruiseNumber')}
                  value={cruiseLineDetailsForDamaged.cruiseNumber}
                  disabled={isReadOnly}
                />
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.departureDate} />
                </PageSectionHeader>
                <DatePicker
                  name="departureDate"
                  type="text"
                  onDayChange={this.props.handleDayChange('form.cruiseLineDetailsForDamaged.departureDate')}
                  value={cruiseLineDetailsForDamaged.departureDate}
                  disabled={isReadOnly}
                />
              </div>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.arrivalDate} />
                </PageSectionHeader>
                <DatePicker
                  name="arrivalDate"
                  type="text"
                  onDayChange={this.props.handleDayChange('form.cruiseLineDetailsForDamaged.arrivalDate')}
                  value={cruiseLineDetailsForDamaged.arrivalDate}
                  disabled={isReadOnly}
                />
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.departurePort} />
                </PageSectionHeader>
                <Textbox
                  name="departurePort"
                  type="text"
                  onChange={this.props.handleChange('form.cruiseLineDetailsForDamaged.departurePort')}
                  value={cruiseLineDetailsForDamaged.departurePort}
                  disabled={isReadOnly}
                />
              </div>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.arrivalPort} />
                </PageSectionHeader>
                <Textbox
                  name="arrivalPort"
                  type="text"
                  onChange={this.props.handleChange('form.cruiseLineDetailsForDamaged.arrivalPort')}
                  value={cruiseLineDetailsForDamaged.arrivalPort}
                  disabled={isReadOnly}
                />
              </div>
            </div>
          </div>
        }
        {typeOfTransportForDamaged === 'other' &&
          <div className={'ml-2'}>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled} />
                </PageSectionHeader>
                <TextArea
                  name="pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled"
                  type="text"
                  onChange={this.props.handleChange('form.otherDetailsForDamaged.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled')}
                  value={otherDetailsForDamaged.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled}
                  disabled={isReadOnly}
                />
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.departureDate} />
                </PageSectionHeader>
                <DatePicker
                  name="departureDate"
                  type="text"
                  onDayChange={this.props.handleDayChange('form.otherDetailsForDamaged.departureDate')}
                  value={otherDetailsForDamaged.departureDate}
                  disabled={isReadOnly}
                />
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.departureLocation} />
                </PageSectionHeader>
                <Textbox
                  name="departureLocation"
                  type="text"
                  onChange={this.props.handleChange('form.otherDetailsForDamaged.departureLocation')}
                  value={otherDetailsForDamaged.departureLocation}
                  disabled={isReadOnly}
                />
              </div>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.destination} />
                </PageSectionHeader>
                <Textbox
                  name="destination"
                  type="text"
                  onChange={this.props.handleChange('form.otherDetailsForDamaged.destination')}
                  value={otherDetailsForDamaged.destination}
                  disabled={isReadOnly}
                />
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.descriptionOfTravelType} />
                </PageSectionHeader>
                <Textbox
                  name="descriptionOfTravelType"
                  type="text"
                  onChange={this.props.handleChange('form.otherDetailsForDamaged.descriptionOfTravelType')}
                  value={otherDetailsForDamaged.descriptionOfTravelType}
                  disabled={isReadOnly}
                />
              </div>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.descriptionOfEvent} />
                </PageSectionHeader>
                <Textbox
                  name="descriptionOfEvent"
                  type="text"
                  onChange={this.props.handleChange('form.otherDetailsForDamaged.descriptionOfEvent')}
                  value={otherDetailsForDamaged.descriptionOfEvent}
                  disabled={isReadOnly}
                />
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}

FlightDetailsForDamagedLost.propTypes = {
  form: PropTypes.object,
  getFlightStatus: PropTypes.func,
  isReadOnly: PropTypes.bool,
  summaryFormValue: PropTypes.func,
  isSummary: PropTypes.bool,
  handleChangeTypeOfTransport: PropTypes.func,
  checkFlightNumberOnly: PropTypes.func,
  checkFlightDateOnly: PropTypes.func,
  loading: PropTypes.bool,
  handleChange: PropTypes.func,
  handleDayChange: PropTypes.func,
  handleChangeFlightDetail: PropTypes.func,
  validatorGroup: PropTypes.object,
  validationCounter: PropTypes.number,
  flightVerificationForDamaged: PropTypes.func,
  showSpinnerForElement: PropTypes.func,
  handleFlightSelection: PropTypes.func,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.Starr.StepBaggageAndPersonalItems/components/FlightDetailsForDamagedLost/index.js